(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chaism-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chaism-footer')) {
    customElements.define('chaism-footer', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const top = this.querySelector('.cf__top-btn');
        if (top) top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }));

        /* The wordmark rises into place when the footer comes into view */
        const mark = this.querySelector('.cf__mark');
        if (!mark || reduce || this.dataset.motion !== 'true' || !('IntersectionObserver' in window)) return;
        this.classList.add('is-motion');
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            mark.classList.toggle('is-in', entry.isIntersecting);
          });
        }, { threshold: 0.25 });
        this.io.observe(mark);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-mosaic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-mosaic-motion')) {
    var FM_NUMBER = /^([\d,]*\.?\d+)(.*)$/;

    class FeatureMosaicMotion extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.dataset.motion === 'true' && 'IntersectionObserver' in window) this.setupReveal();
        this.setupScrollEffects();
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.leaveObserver) this.leaveObserver.disconnect();
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.onEditorSelect) {
          document.removeEventListener('shopify:section:select', this.onEditorSelect);
          document.removeEventListener('shopify:block:select', this.onEditorSelect);
        }
        if (this.items) this.items.forEach(this.clearTimers, this);
      }

      /* ---------- Scroll reveal ---------- */

      setupReveal() {
        this.stagger = parseInt(this.dataset.stagger || '160', 10);
        this.duration = parseInt(this.dataset.duration || '1100', 10);
        this.countUp = this.dataset.count === 'true';
        this.repeat = this.dataset.repeat === 'true';
        this.items = Array.from(this.querySelectorAll('.fm__header, .fm__tile'));

        if (this.dataset.words === 'true') {
          Array.from(this.querySelectorAll('.fm__heading, .fm__title')).forEach(this.splitWords, this);
        }
        if (this.countUp) {
          Array.from(this.querySelectorAll('.fm__stat-num')).forEach(function (num) {
            var raw = num.textContent.trim();
            if (FM_NUMBER.test(raw)) num.setAttribute('data-fm-target', raw);
          });
        }

        this.classList.add('is-motion');

        // Hide only what is still off screen, so nothing already in view flickers.
        var vh = window.innerHeight;
        this.items.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top > vh * 0.9) this.hide(el, false);
          else if (r.bottom < 0) this.hide(el, true);
        }, this);

        this.revealObserver = new IntersectionObserver(this.onEnter.bind(this), {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.12
        });
        this.items.forEach(function (el) { this.revealObserver.observe(el); }, this);

        if (this.repeat) {
          this.leaveObserver = new IntersectionObserver(this.onLeave.bind(this), { threshold: 0 });
          this.items.forEach(function (el) { this.leaveObserver.observe(el); }, this);
        }

        // In the theme editor, show everything as soon as the section or a block is selected.
        this.onEditorSelect = function (event) {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.revealAll();
        }.bind(this);
        document.addEventListener('shopify:section:select', this.onEditorSelect);
        document.addEventListener('shopify:block:select', this.onEditorSelect);
      }

      onEnter(entries) {
        var hits = entries
          .filter(function (entry) { return entry.isIntersecting && entry.target.classList.contains('is-pending'); })
          .map(function (entry) { return entry.target; });
        if (!hits.length) return;

        hits.sort(function (a, b) {
          var ra = a.getBoundingClientRect();
          var rb = b.getBoundingClientRect();
          var row = Math.round(ra.top / 40) - Math.round(rb.top / 40);
          return row !== 0 ? row : ra.left - rb.left;
        });
        // Scrolling up: start with the tiles nearest the bottom edge.
        var fromTop = hits.every(function (el) { return el.classList.contains('is-from-top'); });
        if (fromTop) hits.reverse();

        hits.forEach(function (el, i) {
          if (!this.repeat) this.revealObserver.unobserve(el);
          this.reveal(el, i * this.stagger);
        }, this);
      }

      onLeave(entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          this.hide(entry.target, entry.boundingClientRect.top < 0);
        }, this);
      }

      hide(el, fromTop) {
        this.clearTimers(el);
        el.classList.add('is-resetting');
        el.classList.remove('is-in');
        el.classList.add('is-pending');
        el.classList.toggle('is-from-top', !!fromTop);
        el.style.removeProperty('--fm-delay');
        var num = el.querySelector('.fm__stat-num[data-fm-target]');
        if (num) num.textContent = this.formatCount(0, num.getAttribute('data-fm-target').match(FM_NUMBER));
        void el.offsetWidth;
        el.classList.remove('is-resetting');
      }

      reveal(el, delay) {
        this.clearTimers(el);
        el.style.setProperty('--fm-delay', delay + 'ms');
        requestAnimationFrame(function () {
          el.classList.remove('is-pending');
          el.classList.add('is-in');
        });
        var timers = [];
        var num = el.querySelector('.fm__stat-num[data-fm-target]');
        if (num) timers.push(setTimeout(this.runCount.bind(this, num), delay + 320));
        // Clear the delay afterwards so hover effects respond instantly.
        timers.push(setTimeout(function () { el.style.removeProperty('--fm-delay'); }, delay + this.duration * 2 + 400));
        el._fmTimers = timers;
      }

      revealAll() {
        if (!this.items) return;
        this.items.forEach(function (el) {
          if (el.classList.contains('is-pending')) this.reveal(el, 0);
        }, this);
      }

      clearTimers(el) {
        if (el._fmTimers) el._fmTimers.forEach(clearTimeout);
        el._fmTimers = null;
        var num = el.querySelector && el.querySelector('.fm__stat-num');
        if (num && num._fmRaf) {
          cancelAnimationFrame(num._fmRaf);
          num._fmRaf = null;
        }
      }

      /* ---------- Word-by-word headings ---------- */

      splitWords(el) {
        if (el.hasAttribute('data-fm-split')) return;
        var label = el.textContent.replace(/\s+/g, ' ').trim();
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        var index = 0;
        nodes.forEach(function (node) {
          var parts = node.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(' '));
              return;
            }
            var outer = document.createElement('span');
            outer.className = 'fm__w';
            outer.setAttribute('aria-hidden', 'true');
            var inner = document.createElement('span');
            inner.className = 'fm__wi';
            inner.style.setProperty('--w', index++);
            inner.textContent = part;
            outer.appendChild(inner);
            frag.appendChild(outer);
          });
          node.parentNode.replaceChild(frag, node);
        });
        el.setAttribute('aria-label', label);
        el.setAttribute('data-fm-split', '');
        el.classList.add('fm__split');
      }

      /* ---------- Counting numbers ---------- */

      formatCount(value, match) {
        var digits = match[1];
        var decimals = (digits.split('.')[1] || '').length;
        var text = value.toFixed(decimals);
        if (digits.indexOf(',') !== -1) {
          text = Number(text).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        }
        return text + match[2];
      }

      runCount(num) {
        var raw = num.getAttribute('data-fm-target');
        var match = raw.match(FM_NUMBER);
        var target = parseFloat(match[1].replace(/,/g, ''));
        var length = Math.max(900, this.duration * 1.4);
        var start = performance.now();
        var self = this;
        function step(now) {
          var p = Math.min(1, (now - start) / length);
          var eased = 1 - Math.pow(1 - p, 4);
          num.textContent = p < 1 ? self.formatCount(target * eased, match) : raw;
          num._fmRaf = p < 1 ? requestAnimationFrame(step) : null;
        }
        num._fmRaf = requestAnimationFrame(step);
      }

      /* ---------- Parallax and layered drift ---------- */

      setupScrollEffects() {
        var strength = parseFloat(this.dataset.parallax || '0');
        var depth = parseFloat(this.dataset.depth || '0');
        if (!strength && !depth) return;
        var tiles = Array.from(this.querySelectorAll('.fm__tile'));
        var grid = this.querySelector('.fm__grid');
        if (!tiles.length || !grid) return;
        var tablet = window.matchMedia('(min-width: 750px)');
        var desktop = window.matchMedia('(min-width: 990px)');
        var self = this;

        function update() {
          self.raf = null;
          var vh = window.innerHeight;
          var g = grid.getBoundingClientRect();
          tiles.forEach(function (tile) {
            var r = tile.getBoundingClientRect();
            if (r.bottom < -200 || r.top > vh + 200) return;
            var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
            progress = Math.max(-1, Math.min(1, progress));

            if (strength && tile.classList.contains('fm__tile--image') && tablet.matches) {
              tile.style.setProperty('--fm-py', (progress * r.height * strength / 200).toFixed(1) + 'px');
            } else {
              tile.style.removeProperty('--fm-py');
            }

            if (depth && desktop.matches) {
              // Tiles further right drift a little more, so each column moves at its own pace.
              var factor = 0.35 + 0.65 * ((r.left + r.width / 2 - g.left) / g.width);
              tile.style.setProperty('--fm-depth', (progress * depth * factor).toFixed(1) + 'px');
            } else {
              tile.style.removeProperty('--fm-depth');
            }
          });
        }

        this.onScroll = function () {
          if (!self.raf) self.raf = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        update();
      }
    }

    customElements.define('feature-mosaic-motion', FeatureMosaicMotion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rich-page-faq')) {
    class RichPageFaq extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.items = Array.from(this.querySelectorAll('.rp__content details'));
        this.items.forEach((d) => this.enhance(d));
        this.classList.add('is-enhanced');
        this.main = this.querySelector('.faq-main');
        if (this.main && this.main.querySelector('details') && this.dataset.search === 'true') this.buildSearch();
        this.buildMenu();
      }

      disconnectedCallback() {
        if (this.spy) this.spy.disconnect();
      }

      /* Each question: wrap its text, add the round +/− button, animate open and close */
      enhance(d) {
        const summary = d.querySelector(':scope > summary');
        if (!summary || summary.querySelector('.faq-icon')) return;
        const label = document.createElement('span');
        label.className = 'faq-q';
        while (summary.firstChild) label.appendChild(summary.firstChild);
        label.dataset.html = label.innerHTML;
        const icon = document.createElement('span');
        icon.className = 'faq-icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.append(label, icon);
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle(d, !d.open || d.classList.contains('is-closing'));
        });
      }

      toggle(d, open) {
        const summary = d.querySelector(':scope > summary');
        const start = d.getBoundingClientRect().height;
        if (d._anim) d._anim.cancel();
        d._anim = null;
        if (open) {
          if (this.dataset.single === 'true') {
            this.items.forEach((o) => { if (o !== d && o.open && !o.classList.contains('is-closing')) this.toggle(o, false); });
          }
          d.classList.remove('is-closing');
          d.open = true;
          if (this.reduce) return;
          const end = d.getBoundingClientRect().height;
          d._anim = d.animate({ height: [start + 'px', end + 'px'] }, { duration: 420, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
          const body = d.querySelector(':scope > :not(summary)');
          if (body) body.animate({ opacity: [0, 1], transform: ['translateY(-6px)', 'none'] }, { duration: 420, delay: 60, easing: 'ease-out', fill: 'backwards' });
          d._anim.onfinish = () => { d._anim = null; };
        } else {
          if (this.reduce) { d.open = false; return; }
          d.classList.add('is-closing');
          const end = summary.getBoundingClientRect().height;
          d._anim = d.animate({ height: [start + 'px', end + 'px'] }, { duration: 320, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
          d._anim.onfinish = () => { d.open = false; d.classList.remove('is-closing'); d._anim = null; };
        }
      }

      /* Search box: filters questions and answers as you type */
      buildSearch() {
        if (this.main.querySelector('.faq-search')) return;
        const wrap = document.createElement('div');
        wrap.className = 'faq-search';
        wrap.innerHTML =
          '<label class="faq-search__field">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>' +
          '<span class="visually-hidden" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;">Search the FAQ</span>' +
          '<input type="search" autocomplete="off" spellcheck="false">' +
          '</label>' +
          '<button type="button" class="faq-search__clear" aria-label="Clear search" hidden>&times;</button>';
        const input = wrap.querySelector('input');
        input.placeholder = this.dataset.placeholder || 'Search questions';
        const clear = wrap.querySelector('button');
        const status = document.createElement('p');
        status.className = 'faq-search__status';
        status.setAttribute('aria-live', 'polite');
        this.empty = document.createElement('div');
        this.empty.className = 'faq-empty';
        this.empty.hidden = true;
        this.empty.innerHTML = '<p>No questions match “<span></span>”.</p><a href="#contact">Ask us directly →</a>';
        this.main.prepend(wrap, status);
        const contact = this.main.querySelector('.contact');
        if (contact) contact.before(this.empty); else this.main.append(this.empty);
        this.status = status;

        const run = () => {
          clear.hidden = !input.value;
          this.filter(input.value);
        };
        input.addEventListener('input', run);
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { input.value = ''; run(); }
        });
        clear.addEventListener('click', () => { input.value = ''; run(); input.focus(); });
      }

      filter(query) {
        const terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
        const items = Array.from(this.main.querySelectorAll('details'));
        const escape = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const pattern = terms.length ? new RegExp('(' + terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'gi') : null;
        const mark = (root) => {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach((node) => {
            if (!pattern.test(node.nodeValue)) return;
            pattern.lastIndex = 0;
            const span = document.createElement('span');
            span.innerHTML = escape(node.nodeValue).replace(pattern, '<mark class="faq-hit">$1</mark>');
            node.replaceWith(...span.childNodes);
          });
        };
        let shown = 0;
        items.forEach((d) => {
          const label = d.querySelector('.faq-q');
          const body = d.querySelector(':scope > :not(summary)');
          if (body && d._bodyHtml === undefined) d._bodyHtml = body.innerHTML;
          if (body) body.innerHTML = d._bodyHtml;
          if (label) label.innerHTML = label.dataset.html;
          const text = d.textContent.toLowerCase();
          const match = terms.every((t) => text.includes(t));
          d.hidden = !match;
          if (match) shown += 1;
          if (pattern && match) {
            if (label) mark(label);
            if (body) mark(body);
          }
        });
        /* While searching, open the matching answers so you can see why they matched; close them again afterwards */
        const openAll = terms.length && shown <= 8;
        items.forEach((d) => {
          if (openAll && !d.hidden) {
            if (!d.open) { d.open = true; d._autoOpened = true; }
          } else if (d._autoOpened) {
            d.open = false;
            d._autoOpened = false;
          }
        });
        this.main.querySelectorAll('.faq-section').forEach((sec) => {
          const visible = sec.querySelector('details:not([hidden])');
          sec.hidden = !visible;
          const link = this.querySelector('.faq-toc a[href="#' + sec.id + '"]');
          if (link) link.classList.toggle('is-dim', !visible);
        });
        this.status.textContent = terms.length ? shown + ' of ' + items.length + ' questions' : '';
        this.empty.hidden = !(terms.length && shown === 0);
        this.empty.querySelector('span').textContent = query.trim();
      }

      /* Menu: smooth jump on click, and mark the topic you're reading */
      buildMenu() {
        const links = Array.from(this.querySelectorAll('.faq-toc a[href^="#"]'));
        if (!links.length) return;
        const targets = new Map();
        links.forEach((a) => {
          const target = document.getElementById(a.getAttribute('href').slice(1));
          if (!target) return;
          targets.set(target, a);
          a.addEventListener('click', (e) => {
            e.preventDefault();
            target.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'start' });
            history.replaceState(null, '', a.getAttribute('href'));
            this.setActive(a);
          });
        });
        this.links = links;
        this.setActive(links[0]);
        this.spy = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActive(targets.get(entry.target));
          });
        }, { rootMargin: '-25% 0px -65% 0px' });
        targets.forEach((_, target) => this.spy.observe(target));
      }

      setActive(link) {
        if (!link || link === this.active) return;
        this.links.forEach((a) => a.classList.toggle('is-active', a === link));
        this.active = link;
        const toc = link.parentElement;
        if (toc && toc.scrollWidth > toc.clientWidth) {
          toc.scrollTo({ left: link.offsetLeft - 24, behavior: this.reduce ? 'auto' : 'smooth' });
        }
      }
    }
    customElements.define('rich-page-faq', RichPageFaq);
  }

  } catch(e) { console.error(e); }
})();
})();
